module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 6c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.966 9.966 0 01-6.918-2.78 1.024 1.024 0 01-.346-.763 1 1 0 011.76-.65 8 8 0 10-.846-10.673h1.855a1 1 0 110 2H7.763a1.5 1.5 0 01-1.5-1.5V7.89a1 1 0 112 0L8.26 9.666A9.98 9.98 0 0116 6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/basic/asda-reload.svg
// module id = 624
// module chunks = 0